/**
 * Feature-flag client helpers.
 *
 * `FeatureControllerService.ts` is auto-generated (openapi-typescript-codegen)
 * and marked do-not-edit. New flags that arrive before the next codegen run
 * are queried via this thin wrapper until they appear in the generated service.
 */

import { OpenAPI } from '../api/core/OpenAPI';
import { request as __request } from '../api/core/request';

export interface FeatureFlagResponse {
  enabled: boolean;
}

/** GET /api/features/campaignSplitting — tenant-scoped, default true. */
export function getCampaignSplittingFlag(): Promise<FeatureFlagResponse> {
  return __request(OpenAPI, {
    method: 'GET',
    url: '/api/features/campaignSplitting',
  }) as unknown as Promise<FeatureFlagResponse>;
}

/** GET /api/features/mobileTimeRecording — JVM-property driven, default false. */
export function getMobileTimeRecordingFlag(): Promise<FeatureFlagResponse> {
  return __request(OpenAPI, {
    method: 'GET',
    url: '/api/features/mobileTimeRecording',
  }) as unknown as Promise<FeatureFlagResponse>;
}

/** GET /api/features/routingWeekdayVariants — JVM-property driven, default false.
 *  When on, the RoutingsPage exposes the weekday/holiday variant tab and the
 *  backend resolver picks day-dependent variants at ProductionOrder creation. */
export function getRoutingWeekdayVariantsFlag(): Promise<FeatureFlagResponse> {
  return __request(OpenAPI, {
    method: 'GET',
    url: '/api/features/routingWeekdayVariants',
  }) as unknown as Promise<FeatureFlagResponse>;
}
